var version = {
    "name":      "dativery",
    "buildDateCode": "20261020-133438",
    "buildDate": "Tue Oct 20 2026 13:34:38 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20261020-133438",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;